photoViewerDirective.$inject = ["$parse", "photoViewerDefaultOptions"];
magnificPopupDirective.$inject = ["$parse", "photoViewerDefaultOptions"];
pluginDirective.$inject = ["photoViewerDefaultOptions"];
import 'viewerjs/dist/viewer.min.css';
import Viewer from 'viewerjs';

function create(target, opts) {
  var photoViewer;
  var el;

  if (target.nodeName === "A") {
    target.addEventListener("click", function (e) {
      return e.preventDefault();
    });
    el = target.querySelector("img");
  } else {
    target.querySelectorAll("a").forEach(function (link) {
      return link.addEventListener("click", function (e) {
        return e.preventDefault();
      });
    });
    el = target;
  }

  photoViewer = new Viewer(el, Object.assign({
    url: function url(image) {
      return image.closest("a").href;
    },
    viewed: function viewed() {
      var minZoomRatio = Math.min(this.viewer.imageData.width / this.viewer.imageData.naturalWidth, 1);
      this.viewer.options.minZoomRatio = minZoomRatio;
    }
  }, opts));
  return photoViewer;
} //TODO: compatibility with old version

/*@ngInject*/


function pluginDirective(photoViewerDefaultOptions) {
  return {
    link: function link(scope, element, attrs) {
      if (attrs.plugin === "fancybox") {
        create(element[0], angular.extend({}, photoViewerDefaultOptions));
      }
    }
  };
} //TODO: compatibility with old version

/*@ngInject*/


function magnificPopupDirective($parse, photoViewerDefaultOptions) {
  return {
    link: function link(scope, element, attrs) {
      create(element[0], angular.extend({}, photoViewerDefaultOptions, $parse(attrs.magnificPopupOptions)(scope)));
    }
  };
}
/*@ngInject*/


function photoViewerDirective($parse, photoViewerDefaultOptions) {
  return {
    link: function link(scope, element, attrs) {
      create(element[0], angular.extend({}, photoViewerDefaultOptions, $parse(attrs.photoViewerDefaultOptions)(scope)));
    }
  };
}

;
export { pluginDirective, magnificPopupDirective, photoViewerDirective };